import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // No withCredentials — we use Bearer tokens (JWT in Authorization header) for cross-origin
  // requests. Sending cookies cross-origin breaks behind CDNs that rewrite CORS headers
  // to wildcard, which is incompatible with `withCredentials: true`.
});

// Audio URL resolver — handles both /api/audio/... and absolute https URLs
export const resolveAudio = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${BACKEND_URL}${url}`;
};
